import { OktaAuthService } from '@common_libraries/Services/login/oktaAuth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, Event, NavigationStart, NavigationEnd, NavigationError, RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { SessionService } from '@services/session/session.service';
import { environment } from '@environments/environment';
import { ProjectVersionHandler } from '@common_libraries/helpers/ProjectVersionHandler';
import { LocalStorageService } from 'ngx-webstorage';
import { BuildVersionService } from '@services/buildVersion/build-version.service';
import { SysAdminUserActivityService } from '@services/sysAdmin/sys-admin-user-activity.service';
import parser from 'ua-parser-js';
import { UserService } from '@services/user/user.service';
import { DeactivateDialogService } from '@services/routeSecurity/canDeactiveGuard/DeactivateDialogService.service';
import {
  ServiceLibrary,
  ServiceReturn,
} from '@common_libraries/helpers/ServiceLibrary';
import { GrowlComponent } from '../../common_libraries/controls/Growl/growl.component';
import { MasterTitleComponent } from './pageControls/master-title/master-title.component';
import { LoadingBarModule } from '@ngx-loading-bar/core';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['app.component.scss'],
    providers: [],
    standalone: true,
    imports: [
    LoadingBarModule,
    MasterTitleComponent,
    RouterOutlet,
    GrowlComponent
],
})
export class AppComponent implements OnInit {
  title = 'app works!';
  companyTheme = 'default';

  channelDownload: any;

  isAuthenticated: boolean;

  authReady: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private sessionSvc: SessionService,
    private localSt: LocalStorageService,
    private buildVersionService: BuildVersionService,
    private userActService: SysAdminUserActivityService,
    private userService: UserService,
    private servLib: ServiceLibrary,
    private deactivateDialogService: DeactivateDialogService,
    public oktaAuth: OktaAuthService
  ) {
    if (
      !window.location.href.includes('/login') &&
      !window.location.href.includes('/callback') &&
      !window.location.href.includes('/verifypasswordreset') &&
      !window.location.href.includes('/accountActivation')
    ) {
      this.oktaAuth
        .isAuthenticated('')
        .then((res) => {
          this.authReady = true;
        })
        .catch((res) => {
          this.authReady = false;
          this.oktaAuth.redirectToLogin();
        });
    } else {
      this.authReady = true;
    }

    this.Init();

    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        if (event.url.toLowerCase().indexOf('login.aspx') > -1) {
          window.location.href = environment.webUrl + '/login';
        }
      }

      if (event instanceof NavigationEnd) {
        if (sessionSvc.GetIsLoggedIn() && event.url !== '/') {
          let browser = '';
          let os = '';

          const ua = parser(window.navigator.userAgent);
          if (ua && ua !== undefined && ua !== null) {
            if (ua.browser && ua.browser !== undefined && ua.browser !== null) {
              browser = ua.browser.name + ua.browser.major;
            }

            if (ua.os && ua.os !== undefined && ua.os !== null) {
              os = ua.os.name + ua.os.version;
            }
          }

          this.userActService
            .InsertUserActivity(event.url, browser, os)
            .subscribe((res: any) => {});
        }

        //don't check build version if callback
        if (!event.url.includes('/callback')) {
          const handler = new ProjectVersionHandler(
            this.localSt,
            this.buildVersionService
          );
          handler.VersionCheck();
        }
      }

      if (event instanceof NavigationError) {
      }
    });
  }

  Init() {
    const theme = this.localSt.retrieve('Theme');
    if (theme !== undefined && theme !== null) {
      document.body.className = theme;
    } else {
      document.body.className = 'default';
    }

    if (environment.gaTracking) {
      (<any>window).ga('create', environment.gaTrackingCode, {
        siteSpeedSampleRate: 100,
      });
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          const username = this.sessionSvc.GetUserName();
          (<any>window).ga('set', 'userId', username);
          (<any>window).ga('set', 'page', event.urlAfterRedirects);
          (<any>window).ga('send', 'pageview');
        }
      });
    }
  }

  ngOnInit() {
    this.titleService.setTitle('TigerEye');
    let id: number = null;
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd), // only look at NavigationEnd events
        map(() => this.activatedRoute), // swap out what we are looking at to the ActivatedRoute
        map((route) => {
          // return the last instance of the activated route
          id = null;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'), // Only use primary outlet...multiple outlets would mean multiple firings
        mergeMap((route) => {
          // parse any id params and pass route data along
          if (route.parent) {
            // check parent for id
            route.parent.params.subscribe(
              (params) => (id = Number(params['id']))
            );
          }
          if (isNaN(id)) {
            // if we didn't find an id, check self for id
            route.params.subscribe((params) => (id = Number(params['id'])));
          }
          return route.data;
        })
      )
      .subscribe((event) => {
        // set the page title based on id and title
        if (isNaN(id)) {
          this.titleService.setTitle(event['title']);
        } else {
          this.titleService.setTitle(event['title'] + id.toString());
        }
      });
  }
}
